import { core } from '../core/index.js';
import { filterFabricErrors } from '../errors/errors.js';

/**
 * Android专用，同步方法
 * 检查当前是否有权限读取APP站外目录权限, 业务上可以判断在有权限再去读取站外目录, 避免权限弹窗干扰
 */
export const getOutsidePathReadPermissionStatus: FabricUtilsGetOutsidePathReadPermissionStatusApi =
  () => {
    const result = core.call<
      'fabric_utils.getOutsidePathReadPermissionStatus',
      FabricUtilsGetOutsidePathReadPermissionCallbackData
    >('fabric_utils.getOutsidePathReadPermissionStatus');
    const fabricErrors = filterFabricErrors(
      result.code,
      result.message,
      result.data
    );
    if (fabricErrors) {
      throw fabricErrors;
    } else {
      return result.data;
    }
  };

/**
 * Android专用，异步调用
 * 向用户索要APP站外目录读取权限, 没有权限时会向用户弹出授权弹窗
 */
export const getOutsidePathReadPermission: FabricUtilsGetOutsidePathReadPermissionApi =
  () => {
    return new Promise<FabricUtilsGetOutsidePathReadPermissionCallbackData>(
      (resolve, reject) => {
        core.call<
          'fabric_utils.getOutsidePathReadPermission',
          null,
          FabricUtilsGetOutsidePathReadPermissionCallbackData
        >('fabric_utils.getOutsidePathReadPermission', null, (result) => {
          const fabricErrors = filterFabricErrors(
            result.code,
            result.message,
            result.data
          );
          if (fabricErrors) {
            reject(fabricErrors);
          } else {
            resolve(result.data);
          }
        });
      }
    );
  };

/**
 * 返回当前是否有权限读取APP站外目录权限
 * 用户同意后返回: { allowed: true }，没有权限时跑出统一的权限拒绝错误码: ntv_permission_reject
 */
export type FabricUtilsGetOutsidePathReadPermissionCallbackData = {
  allowed: boolean;
};

/**
 * 使用场景举例：
 * 判断文件存储的路径是否是存储截屏图片的目录，来监听用户动作是否是截屏操作
 */
export type FabricUtilsGetOutsidePathReadPermissionApi =
  () => Promise<FabricUtilsGetOutsidePathReadPermissionCallbackData>;

export type FabricUtilsGetOutsidePathReadPermissionStatusApi =
  () => FabricUtilsGetOutsidePathReadPermissionCallbackData;
